
import { triggerAnimation } from '~/utils/trigger'

export default {
  props: {
    item: {
      default: () => ({}),
    },
  },
  mounted() {
    setTimeout(() => {
      triggerAnimation(document.querySelectorAll('.main2'), 'fadeInLeftBig')
      triggerAnimation(document.querySelectorAll('.main1'), 'fadeInRightBig')
    }, 250)
  },
}
